// Reglas de personalización (dorsal) compartidas por la ficha de producto y Tu 11 por Encargo.
// Nombre: máx. 12 caracteres (con espacios). Letras (mayúsculas y minúsculas, se respeta como las escribe el cliente),
// acentos latinos, espacios, guiones y apóstrofe. Número: 0 a 99, se guarda tal como lo escribe (00 y 09 se respetan).
(function () {
  if (window.OnceIdealDorsal) return;

  var NAME_MAX = 12;
  var NAME_INVALID = /[^A-Za-zÀ-ÖØ-öø-ÿĀ-ſ .’-]/g;
  var LETTER = /[A-Za-zÀ-ÖØ-öø-ÿĀ-ſ]/;

  function cleanName(raw) {
    var s = String(raw || '');
    if (s.normalize) s = s.normalize('NFC');
    return s
      .replace(/'/g, '’')
      .replace(NAME_INVALID, '')
      .replace(/ {2,}/g, ' ')
      .replace(/^[ -]+/, '')
      .slice(0, NAME_MAX);
  }

  // Solo dígitos, máximo 2. No se quitan los ceros de adelante (00, 09).
  function cleanNumber(raw) {
    return String(raw || '').replace(/[^0-9]/g, '').slice(0, 2);
  }

  function hasLetter(name) {
    return LETTER.test(String(name || ''));
  }

  function counterText(length) {
    var left = NAME_MAX - length;
    if (left <= 0) return 'Llegaste al máximo de ' + NAME_MAX + ' caracteres';
    if (left === 1) return 'Te queda 1 caracter';
    return 'Te quedan ' + left + ' caracteres';
  }

  function renderPreview(el, name, number) {
    if (!el) return;
    var nameText = String(name || '').trim();
    var numberText = String(number || '').trim();
    var nameEl = el.querySelector('[data-oi-prev-name]');
    var numEl = el.querySelector('[data-oi-prev-num]');
    if (nameEl) {
      nameEl.textContent = nameText || 'TU NOMBRE';
      nameEl.classList.toggle('is-placeholder', !nameText);
    }
    if (numEl) {
      numEl.textContent = numberText === '' ? '10' : numberText;
      numEl.classList.toggle('is-placeholder', numberText === '');
    }
  }

  // El nombre personalizado conserva exactamente las mayúsculas/minúsculas que escribe el cliente.
  function relaxInputs() {
    var inputs = document.querySelectorAll('[data-once-ideal-name], [data-oi=nombre]');
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].setAttribute('autocapitalize', 'words');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relaxInputs);
  } else {
    relaxInputs();
  }
  document.addEventListener('shopify:section:load', relaxInputs);

  window.OnceIdealDorsal = {
    NAME_MAX: NAME_MAX,
    cleanName: cleanName,
    cleanNumber: cleanNumber,
    hasLetter: hasLetter,
    counterText: counterText,
    renderPreview: renderPreview
  };
})();
